import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Button from 'react-bootstrap/Button';

import ListHeader from '../list/ListHeader';
import TableUI from '../list/TableUI';
import FilterPannel from '../filter/FilterPannel';

import Const from '../../util/Constants';
import AttendanceAPI from '../../api/AttendanceAPI';
import KeyValueAPI from '../../api/KeyValueAPI';
import ImportExportAPI from '../../api/ImportExportAPI';
import Util from '../../util/Util';
import withRouter from '../../util/WithRouter';
import Display from '../../util/Display';

class AttendanceList extends React.Component {

  constructor(props) {
    super(props);

    const query = new URLSearchParams(props.location.search);
    const filters = query.get('filters') ? JSON.parse(query.get('filters')) : null;

    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.attendance;

    this.data = { attendance: [], attendanceCount: 0 };
    this.list = reactLocalStorage.getObject(Const.ListAttendance);
    
    this.User = parseInt(reactLocalStorage.getObject(Const.LoggedInUser).user_id);

    if(filters) this.list.filters = filters;
    else if(!this.list.filters) { this.list.filters = []; }
    if(!this.list.isFilterOpen) { this.list.isFilterOpen = false; }
    if(!this.list.pagination) { this.list.pagination = { currentPage:1, pageCount:1, perPage: 10}; }

    this.list.fields = ['user_id', 'attendance_day', 'checkin', 'checkin_location',
      'checkout', 'checkout_location', 'in_officetime'];
    this.list.sorting = { field: 'date', order: -1 };
     
    this.state = { inApiCall: true, isFilterOpen: this.list.isFilterOpen, checkIn: false, checkOut: false };

    this.List = Util.isAllow(this.model.permission, Const.PermView);
    this.Add = Util.isAllow(this.model.permission, Const.PermAdd);
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Restrict = Util.isAllow(this.model.permission, Const.PermRestricAcc);
    this.base = this.props.match.path
  }

  saveListFields = list => {
    let fieldList = reactLocalStorage.getObject(Const.FieldList);
    if(fieldList === undefined) fieldList = { };
    fieldList = { ...fieldList, attendance: list };
    let key = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    key = `${Const.FieldList}-${key}`;
    KeyValueAPI.save(key, KeyValueAPI.JSON, fieldList, () => {}, this.props.failure, this.props.logout);
  }

  saveListSort = sort => {
    let fieldList = reactLocalStorage.getObject(Const.FieldList);
    if(!fieldList) fieldList = { };
    fieldList = { ...fieldList, attendance_sort: sort };
    let key = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    key = `${Const.FieldList}-${key}`;
    KeyValueAPI.save(key, KeyValueAPI.JSON, fieldList, () => {});
  }

  componentDidMount() { if(this.List) this.loadAttendance(); }

  loadAttendance = () => {
    //const filters = ViewController.filters([...this.list.filters], [], [], this.Restrict, 'user_id');
    let filters = [ ...this.list.filters ];
    if(this.Restrict) {
      filters = filters.filter(filter => filter.field !== 'user_id');
      filters.push({field: 'user_id', type: 'multiselect~user',
          condition: 'in', value: `${Const.Opt}${this.User}${Const.Opt}`});
    }

    this.setState({ ...this.state, inApiCall: true });
    reactLocalStorage.setObject(Const.ListAttendance, this.list);
    AttendanceAPI.list({ ...this.list, filters }, this.onReceived, this.props.failure, this.props.logout);
  }

  onReceived = res => {
    this.data.attendances = res.data;
    this.data.count = res.count;
    this.list.pagination.pageCount = Math.ceil(res.count / this.list.pagination.perPage);
    AttendanceAPI.getCheckinStatus(this.User, this.onCheckinStatus, this.props.failure, this.props.logout);
  }

  onCheckinStatus = res => {
    const checkIn = res.count === 0;
    const checkOut = res.count === 1 && !res.data[0].checkout;
    if(checkOut) {
      this.attendance = res.data[0];
    }
    this.setState({ ...this.state, inApiCall: false, checkIn, checkOut});
  }
  
  onCheckIn = () => {
  if (navigator.geolocation) {
    this.setState({ ...this.state, inApiCall: true });
    navigator.geolocation.getCurrentPosition(this.checkInPosition, this.showError);
  } else {
    Util.showError("Geolocation is not supported by this browser.");
  }
}

  showError = () => {
    this.setState({ ...this.state, inApiCall: false });
    Util.showError("Allow Geolocation from notification")
  }

  checkInPosition = position => {
    const checkin = {
      user_id : this.User, 
      checkin : Util.dateToServerDateTime(new Date()),
      checkinLat: position.coords.latitude,
      checkinLng: position.coords.longitude
    };
    AttendanceAPI.save(checkin, this.onCheckInCompleted, this.failure, this.props.logout);
  }

  onCheckInCompleted = res => {
    this.attendance = res;
    this.loadAttendance();
  }

  onCheckOut = () => {
    if (navigator.geolocation) {
      this.setState({ ...this.state, inApiCall: true });
      navigator.geolocation.getCurrentPosition(this.checkOutPosition, this.showError);
    } else {
      Util.showError("Geolocation is not supported by this browser.");
    }
  }

  checkOutPosition = position => {
    const checkout = {
      ...this.attendance, 
      user_id : this.User, 
      checkout : Util.dateToServerDateTime(new Date()),
      checkoutLat: position.coords.latitude,
      checkoutLng: position.coords.longitude
    };
    AttendanceAPI.save(checkout, this.loadAttendance, this.failure, this.props.logout);
  }

  onPageChange = currentPage => {
    this.list.pagination.currentPage = currentPage;
    this.loadAttendance();
  }

  onPerPageChange = perPage => {
    this.list.pagination.perPage = perPage;
    this.loadAttendance();
  }

  onFieldSelection = fields => {
    this.list.fields = fields;
    reactLocalStorage.setObject(Const.ListAttendance, this.list);
    this.saveListFields(fields);
  }

  onOrderChange = (field, order) => {
    this.list.sorting = { field, order };
    reactLocalStorage.setObject(Const.ListAttendance, this.list);
    this.saveListSort(this.list.sorting);
    this.loadAttendance();
  }

  toggleFilter = () => {
    this.list.isFilterOpen = !this.state.isFilterOpen;
    reactLocalStorage.setObject(Const.ListAttendance, this.list);
    this.setState({ ...this.state, isFilterOpen: !this.state.isFilterOpen });
  }
  closeFilter = () => this.setState({ ...this.state, isFilterOpen: false });
  onFilterChange = filters => { this.list.filters = filters; this.loadAttendance(); }

  onAddEdit = indx => this.props.navigate(`${this.props.match.path}/add-edit/`
    + `${indx !== -1 ? this.data.attendances[indx].id : 0}`);
  onPreview = indx => {};
  onDelete = indx => Util.confirmAlert('Delete', `Are you sure you want to delete to`
    + ` ${Display.ModelName(this.data.attendances[indx])}`, 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      AttendanceAPI.delete(this.data.attendances[indx].id, this.onDeleteSuccess,
        this.props.failure, this.props.logout);
  });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Attendance deleted successfully', 'success');
    this.loadAttendance();
  }

  export = fields => Util.confirmAlert('Export', `Are you sure you want to export to with `
    +` applied filters ? `, 'Export', 'Cancel', () => {
    const filters = [ ...this.list.filters ];
    ImportExportAPI.exportModel(Const.Attendance, filters, this.list.sorting, this.data.count, fields, this.model.model_no,
      this.onExport, this.onFail);
  });
  onExport = () => {
    this.setState({ ...this.state, inApiCall: false });
    Util.showNotification('Successful', 'Attendance Exported in progress.'
      + ' Please visit Settings', 'success');
  }


  render() {
    if(!this.List) return null;
    return (
      <div>
        <ListHeader
          model={this.model}
          name={this.model.label_name}
          pagination={this.list.pagination}
          listCount={this.data.count}
          filterCount={this.list.filters.length}
          onPageChange={this.onPageChange}
          perPage={this.list.pagination.perPage}
          onPerPageChange={this.onPerPageChange}
          toggleFilter={this.toggleFilter}
          onAddClick={() => this.onAddEdit(-1)}
          add={false}
          update={false}
          export={this.export} 
        />

        <div className="container-fluid ">
          <div className="row">
            <div className="col-md-8"></div>
            <div className="col-md-4">
              { this.Add && this.state.checkIn ? 
                <Button className="btn-sm btn-lead" onClick={this.onCheckIn}>Check In</Button> : null }
              { this.Add && this.state.checkOut ? 
                <Button className="btn-sm btn-lead" onClick={this.onCheckOut}>Check Out</Button> : null }
            </div>
          </div>
          <div className="row">
            <TableUI
              data={this.data.attendances}
              model={this.model}
              fields={this.list.fields}
              order={this.list.sorting}
              pagination={this.list.pagination}
              inApiCall={this.state.inApiCall}
              preview={false}
              update={this.Update}
              delete={false}
              onAddEdit={this.onAddEdit}
              onPreview={this.onPreview}
              onDelete={this.onDelete}
              onFieldSelection={this.onFieldSelection}
              onOrderChange={this.onOrderChange}
              isFilterOpen={this.state.isFilterOpen}
            />
            <FilterPannel
              filters={this.list.filters}
              fields={this.model.fields}
              onFilterChange={this.onFilterChange}
              closeFilter={this.closeFilter}
              isFilterOpen={this.state.isFilterOpen}
              restrict={this.Restrict}
            />
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(AttendanceList);